import type { ExpenseListFilters } from 'washday-sdk';

export const expenseKeys = {
  all: ['expenses'] as const,
  lists: (storeId: string) => [...expenseKeys.all, 'list', storeId] as const,
  list: (storeId: string, filters: ExpenseListFilters) =>
    [...expenseKeys.lists(storeId), filters] as const,
  details: (storeId: string) => [...expenseKeys.all, 'detail', storeId] as const,
  detail: (storeId: string, expenseId: string) =>
    [...expenseKeys.details(storeId), expenseId] as const
};
